import type { SVGProps } from 'react'

import { cn } from '@/shared/lib/utils'

const CmpLogoIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
	<svg
		fill='currentColor'
		viewBox='0 0 56 56'
		role='presentation'
		width={16}
		height={16}
		className={cn('size-4', className)}
		{...props}
	>
		<path d='M.113 26.295c-.651 10.334 4.61 20.16 13.626 25.444a28.24 28.24 0 0 0 29.142-.374c8.873-5.515 13.874-15.471 12.951-25.786l-9.27.832c.837 9.469-5.765 18.009-15.234 19.705-9.469 1.697-18.687-4.008-21.272-13.163s2.317-18.748 11.308-22.135l-3.354-8.6C7.782 6.087.785 15.499.113 26.296' />
		<path d='M29.142 9.628c6.391.382 12.134 3.984 15.202 9.534l8.337-4.117C48.121 6.561 39.421 1.03 29.714.443a30 30 0 0 0-2.532-.036l.359 9.193a18 18 0 0 1 1.601.028' />
	</svg>
)

export default CmpLogoIcon
